"use client"

import React, { Component, ErrorInfo, ReactNode } from "react"

/**
 * References:
 * Vercel: https://github.com/vercel/next.js/blob/0bd5fd08309bebcdfb1d4c855c1f2e81a1aed97b/docs/01-app/04-api-reference/03-file-conventions/error.mdx#graceful-error-recovery-with-a-custom-error-boundary
 * NextJs: https://nextjs.org/docs/14/app/building-your-application/routing/error-handling
 */

interface ErrorBoundaryProps {
    children: ReactNode
    onError?: (error: Error, errorInfo: ErrorInfo) => void
}

interface ErrorBoundaryState {
    hasError: boolean
}

export class GracefullyDegradingErrorBoundary extends Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    private contentRef: React.RefObject<HTMLDivElement>

    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
        this.contentRef = React.createRef()
    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        return { hasError: true }
    }
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (this.props.onError) {
            this.props.onError(error, errorInfo)
        }
    }

    render() {
        if (this.state.hasError) {
            // Render the current HTML content without hydration
            return (
                <>
                    <div
                        ref={this.contentRef}
                        suppressHydrationWarning
                        dangerouslySetInnerHTML={{
                            __html: this.contentRef.current?.innerHTML || ""
                        }}
                    />
                    {/* should not be needed ? */}
                    {/* <div className="fixed bottom-0 left-0 right-0 bg-red-600 px-6 py-4 text-center text-white">
                        <p className="font-semibold">
                            An error occurred during page rendering
                        </p>
                    </div> */}
                </>
            )
        }

        return <div ref={this.contentRef}>{this.props.children}</div>
    }
}

export default GracefullyDegradingErrorBoundary
